import { useEffect, useState } from 'react'
import { Box } from '@chakra-ui/react'
import { SplitPayContext } from '../context/SplitPayContext'
import StartPage from './splitpay/StartPage'
import PaymentPage from './splitpay/PaymentPage'

export default function SplitPayForm() {
  const [splitState, setSplitState] = useState({
    splitId: -1,
    state: 0,
    formNumber: 1,
    address: '',
    recipients: [],
    shares: [],
    amountReleased: [],
    contractAddress: '',
    totalShares: 0,
    totalReleased: 0,
  })

  function nextForm(num: number) {
    setSplitState({ ...splitState, formNumber: num })
  }

  function previousForm() {
    setSplitState({ ...splitState, state: 0, formNumber: splitState.formNumber - 1 })
  }

  useEffect(() => {
    if (splitState.state === 0) {
      nextForm(1)
    } else {
      nextForm(2)
    }
  }, [splitState.state])

  return (
    <Box
      borderWidth="1px"
      rounded="lg"
      shadow="1px 1px 3px rgba(0,0,0,0.3)"
      maxW={{ base: 'xl', md: 'lg' }}
      p={{ base: '6' }}
      m="10px"
      as="form"
    >
      <SplitPayContext.Provider value={{ splitState: splitState, setSplitState, previousForm }}>
        {splitState.formNumber === 1 && <StartPage />}
        {splitState.formNumber === 2 && <PaymentPage />}
      </SplitPayContext.Provider>
    </Box>
  )
}
